import React from "react";
import {
  Article,
  Section,
  SectionHeader,
  SectionTitle,
} from "../../styles/ResumeStyles";

const AdditionalInfo = () => {
  return (
    <Article>
      <Section>
        <SectionHeader>
          <SectionTitle>Additional Information</SectionTitle>
        </SectionHeader>
        <div>
          <p>
            Career switcher from architecture to web development, with 2.5 years
            of experience as a graphic designer.
          </p>
          <p>
            Passionate about learning new skills and taking on new challenges.
          </p>
        </div>
      </Section>
    </Article>
  );
};

export default AdditionalInfo;
